import { CALL_API } from "../../Common/api";

// TraKing vehicle data, fetched through the TrackRight backend. The backend
// scopes it to the logged-in account's TraKing company (MASTERCOMP.NexusCompId);
// only the Nexus operator account (MCID 59) can pass a company_id.
// Resolves to the same `{ response }` shape TraKing's own API returned.

export const fetchNexusAssets = async (companyId) => {
  const qs = companyId ? `?company_id=${encodeURIComponent(companyId)}` : "";
  const { data } = await CALL_API("GET", `nexus/nexusvehicles${qs}`);
  return { response: Array.isArray(data?.response) ? data.response : [] };
};

export const fetchNexusAssetInfo = async (assetId) => {
  const { data } = await CALL_API(
    "GET",
    `nexus/nexusvehicleinfo?asset_id=${encodeURIComponent(assetId)}`,
  );
  return { response: data?.response ?? null };
};

// Fences of one group (e.g. "Consignor", "Consignee") for the logged-in
// account's company. Only the Nexus operator (MCID 59) passes a company_id.
export const fetchNexusFences = async (group, companyId) => {
  const qs = new URLSearchParams({
    group,
    ...(companyId ? { company_id: companyId } : {}),
  }).toString();
  const { data } = await CALL_API("GET", `nexus/nexusfences?${qs}`);
  const list = Array.isArray(data?.response) ? data.response : [];
  return list.map((f) => ({
    ...f,
    geofence_id: f.geofence_id ?? f.geofenceId ?? f.id,
    name: f.name ?? f.geofence_name ?? f.fence_name,
  }));
};
